module.exports = __webpack_public_path__ + "static/media/howLongQuestion.67b97eb5.mp3";